@if (isStep2) {
  <app-space-step2> </app-space-step2>
} @else {
  <app-space-step1></app-space-step1>
}
